/**
 * Tooltip Hook
 * Manages tooltip visibility, positioning, and content
 */

import { useState, useCallback, RefObject } from 'react';
import type { TooltipData, TruckTimelineData } from '../types';

interface UseTooltipProps {
  svgRef: RefObject<SVGSVGElement | null>;
}

export const useTooltip = ({ svgRef }: UseTooltipProps) => {
  const [tooltip, setTooltip] = useState<TooltipData>({
    visible: false,
    x: 0,
    y: 0,
    truckName: '',
    vin: '',
    licensePlate: '',
  });

  const handleBarHover = useCallback(
    (event: React.MouseEvent, truckData: TruckTimelineData) => {
      if (!svgRef.current) return;

      const rect = svgRef.current.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;

      setTooltip({
        visible: true,
        x,
        y,
        truckName: truckData.truckName,
        vin: truckData.vin,
        licensePlate: truckData.licensePlate,
      });
    },
    [svgRef]
  );

  const handleBarLeave = useCallback(() => {
    setTooltip((prev) => ({ ...prev, visible: false }));
  }, []);

  return {
    tooltip,
    handleBarHover,
    handleBarLeave,
  };
};
